<div class="container-tab-lists new-table-style">

  <div class="inner-tcontainer-tab">

    <h2>{{title}} {{isAllLoaded === false ? waitHeader : null}}</h2>
    <div style="display:flow-root">
      <div style="float:left; width:40vw">
        <mat-form-field class="search-input">
          <input placeholder="Filter"
            matInput
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event)"
            [disabled]="isAllLoaded === false">
            <mat-chip-grid #chipList>
            </mat-chip-grid>
          </mat-form-field>
          <!--<mat-icon style="color:#ddd !important;" (click)="openFilterPopup()">filter_alt</mat-icon>-->
          @for (item of searchItems; track item) {
            <mat-chip-option [selectable]="selectable"
              [removable]="removable" (removed)="remove(item)">
              {{item.name}}
              @if (removable) {
                <mat-icon matChipRemove>cancel</mat-icon>
              }
            </mat-chip-option>
          }
        </div>
        <div style="text-align:right; float:right">

          @if (isEditModeEnabled) {
            <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
              <span class='glyphicon glyphicon-floppy-disk'></span> Save
            </a>
          }

          <!--  <a class='kpi-button-menu' title="Release Mode" (click)="onClickReleaseMode()" *ngIf="isReleaseActive && canUserRelease()">
          {{'Release All'}}
        </a> -->

        @if (!isEditModeEnabled && canUserRelease()) {
          <a class='kpi-button-menu' title="Release Mode" (click)="toggleRelease(true);isRevokeActive ? toggleRevoke():null">
            {{releaseButtonText}}
          </a>
        }

        <!-- <a class='kpi-button-menu' title="Revoke all released values" (click)="onClickRevoke()" *ngIf="isRevokeActive && canUserRevoke()">
        {{'Revoke All'}}
      </a> -->

      @if (!isEditModeEnabled && canUserRevoke()) {
        <a class='kpi-button-menu' title="Revoke all released values" (click)="toggleRevoke();isReleaseActive ? toggleRelease():null ">
          {{revokeButtonText}}
        </a>
      }

      @if (!isExcelModeEnabled && canUserUpdate()) {
        <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
          <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
        </a>
      }

      @if (!isExcelModeEnabled && !isEditModeEnabled) {
        <a class='kpi-button-menu' title="Excel" (click)="onClickExcel()">
          Excel
        </a>
      }

      @if (isExcelModeEnabled) {
        <a class='kpi-button-menu' title="Dowload" (click)="onClickDownload()">
          <span class='glyphicon glyphicon-download'></span> Download
        </a>
      }

      @if (isExcelModeEnabled && canUserUpdate()) {
        <a class='kpi-button-menu' title="Upload" (click)="onClickUpload()">
          <span class='glyphicon glyphicon-upload'></span> Upload
        </a>
      }

      @if (isExcelModeEnabled) {
        <a class='kpi-button-menu' title="Excel" (click)="onClickExitExcel()">
          Exit Excel Mode
        </a>
      }

      @if (!isShowAllEnabled) {
        <a class='kpi-button-menu' title="Show All" (click)="onClickShowAllButton()">
          <span class='glyphicon glyphicon-eye-open'></span> Show All
        </a>
      }

      @if (isShowAllEnabled) {
        <a class='kpi-button-menu' title="Hide empty" (click)="onClickShowAllButton()">
          <span class='glyphicon glyphicon-eye-close'></span> Hide empty
        </a>
      }

      <h5>
        @if (!isComparisonMismatch) {
          <span> /</span>
        }
        @if (isShowAllEnabled === true) {
          <span>Showing all available entries </span>
        }
        @if (isShowAllEnabled === false) {
          <span>Excluding empty values </span>
        }
        @if (showReleaseLabel === true || isEditModeEnabled === true) {
          <span> / </span>
        }
        @if (isEditModeEnabled === true) {
          <span class="salmon-color">Editable kpi values</span>
        }
        @if (showReleaseLabel === true && isEditModeEnabled === true) {
          <span>/</span>
        }
        @if (showReleaseLabel === true) {
          <span class="green-release-color">Released kpi values </span>
        }
      </h5>

      <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
        Edit Mode is enabled. Please click on Save button to save all changes
      </h5>
    </div>
  </div>
  <br />

  <market-sheet-list [list]="list"
    [isEditModeEnabled]="isEditModeEnabled"
    [filter]="filter"
    [auxFilterPredicate]="auxFilterPredicate"
    (onUpdateSelectorKpiUnit)="updateSelectorKpiUnit($event)"
    [selectorKpiUnitFilter]="selectorKpiUnitFilter"
    [isShowAllEnabled]="isShowAllEnabled"
    [isReleaseActive]="isReleaseActive && !isEditModeEnabled"
    [isRevokeActive]="isRevokeActive && !isEditModeEnabled"
    (onClickRevokeMode)="onClickRevoke()"
  (onClickReleaseMode)="onClickReleaseMode()"></market-sheet-list>
  <!--  <div *ngIf='isLoading' class="blackbg card__desc">
  <div *ngFor="let _ of [].constructor(8)" class="card__desc-text lg"></div>
</div> -->
</div>
</div>